module.exports = __webpack_public_path__ + "static/img/12.9fedfe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/12.png
// module id = CWvS
// module chunks = 0